const getApiErrorMessage = (error, fallback) => {
  const data = error?.response?.data;
  return (
    data?.message?.description ||
    data?.message ||
    data?.error ||
    fallback
  );
};

export default getApiErrorMessage;
